let backendUrl:string;
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'){
  backendUrl = "http://localhost:8080"
  // backendUrl = "https://backend.mesprotocol.com"
}else{
  backendUrl = "https://backend.mesprotocol.com"
}
export const backendPrefix = backendUrl;